import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SubscriptionComponent from './subscription.component';

let SubscriptionModule = angular
  .module('Subscription', [
    uiRouter
  ])
  .component('subscription', SubscriptionComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state('accountSubscription', {
      params: { },
      data: {
        authRequired: true,
        paymentExempt: true,
        permsRequired: ['manage-subscription']
      },
      views: {
        'menu': "",
        'content': {
          component: 'subscription',
          bindings: {
            pointOfSalesCount: 'pointOfSalesCount',
            spinPadCount: 'spinPadCount',
          }
        }
      },
      resolve: {
        pointOfSalesUnitPrice: () => 30.00,
        spinPadUnitPrice: () => 5.00,
      }
    });
  })
  .name;

export default SubscriptionModule;



// WEBPACK FOOTER //
// ./src/app/pages/subscription/subscription.module.js